const EMAIL_KEY = 'userEmail';

export function get() {
    return window.sessionStorage ? sessionStorage.getItem(EMAIL_KEY) : null;
}

export function set(email) {
    if (window.sessionStorage && typeof email === 'string') {
        sessionStorage.setItem(EMAIL_KEY, email);
    }
}

export function clear() {
    if (window.sessionStorage) {
        window.sessionStorage.removeItem(EMAIL_KEY);
    }
}